import { gql } from "@apollo/client";

const KNOWLEDGE_SOURCE_PROCESSING = gql`
  subscription OnKnowledgeSourceProcessing($botId: String!) {
    knowledgeSourceProcessing(botId: $botId) {
      id
      sourceId
      sourceName
      sourceType
      status
      processingProgress
      totalChunks
      errorMessage
      createdAt
    }
  }
`;
export default KNOWLEDGE_SOURCE_PROCESSING;
